import { useState } from 'react'
import { Container, Dropdown} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../auth/useAuth'
import { Link } from 'react-router-dom'

export default function MenuClerk() {
	const { t } = useTranslation()
	const { clientauth, logoutClient } = useAuth()

  	return (
		// <Container className="d-none d-md-flex justify-content-end align-items-center">
		// 	<div className='me-3'>{clientauth?.name}</div>
		// 	<Dropdown className=''>
		// 		<Dropdown.Toggle variant='drop' id="dropdown-basic" className='ms-auto'>
		// 			<i className="fas fa-bars"></i>
		// 		</Dropdown.Toggle>
		// 			<Dropdown.Menu>
		// 				<Dropdown.Item as={Link} to="/" onClick={logoutClient}>{t('menus.logout')}</Dropdown.Item>
		// 			</Dropdown.Menu>
		// 	</Dropdown>
		// </Container>
		<></>
	)
}